import { create } from "zustand";
import { isUnitSystem, type UnitSystem } from "./units";

const KEY = "twelve-volt:units";

/** Imperial only for en-US — en-CA, en-GB and en-AU deliberately get metric. */
function detectDefault(): UnitSystem {
  if (typeof navigator === "undefined") return "metric";
  const tag = (navigator.language ?? "").toLowerCase();
  return tag === "en-us" ? "imperial" : "metric";
}

function readStored(): UnitSystem | null {
  try {
    const v = localStorage.getItem(KEY);
    return isUnitSystem(v) ? v : null;
  } catch {
    return null;
  }
}

function writeStored(u: UnitSystem): void {
  try {
    localStorage.setItem(KEY, u);
  } catch {
    /* private mode */
  }
}

interface UnitsState {
  units: UnitSystem;
  setUnits(u: UnitSystem): void;
  toggle(): void;
}

export const useUnits = create<UnitsState>((set, get) => ({
  units: readStored() ?? detectDefault(),
  setUnits: (u) => {
    writeStored(u);
    set({ units: u });
  },
  toggle: () => get().setUnits(get().units === "metric" ? "imperial" : "metric"),
}));
